/**
 * User: WangMeng
 * Date: 2018-07-13
 * Time: 11:01
 * Desc: 财务舞弊、财务风险指标异常
 */
import styles from './indexPane.scss';
import React, { PureComponent } from 'react';
import { Table, Modal } from 'antd';
import { PAGE_SIZE } from '../../../../../constants/common';
import {fieldAnomaly} from '../../../../../utils/formatter';
import EllipsisAndTooltip from '../../../../common/ellipsisAndTooltip/EllipsisAndTooltip';
import BBDLineBar from '../../../../common/echarts/BBDLineBar';
import { removeCommonIndex, avgScatterOption } from '../../../common/commons';
import {isEmpty} from '../../../../../utils/util';

export default class IndexPane extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            chartTitle: '',
            modalOption: {}
        };
    }

    showModal = (data) => {
        const { type } = this.props;
        const { abnormalIndex, list, chart, featureType } = data;
        let state = { visible: true };
        if (type === 'fraud') {
            state.modalOption = avgScatterOption(chart);
            state.chartTitle = featureType === 'raw' ? abnormalIndex : `${abnormalIndex}残差`;
        } else {
            state.modalOption = this.formatRiskTrendOption(list, abnormalIndex);
            state.chartTitle = '数据历史变化情况';
        }
        this.setState(state);
    };

    hideModal = () => {
        this.setState({ visible: false });
    };

    formatRiskTrendOption = (data, name) => {
        if(isEmpty(data)) {
            return {};
        }
        let category = [], currentData = [], averageData = [];
        data = data.reverse();
        data.forEach(d => {
            category.push(d.year);
            currentData.push(d.current);
            averageData.push(d.average);
        });

        return {
            color: ['#3370C8', '#F99248'],
            grid: {
                top: 25,
                right: 20
            },
            legend: {
                type: 'scroll',
                right: 20,
                itemGap: 10
            },
            category,
            lineData: [
                { name: `${name}`, data: currentData },
                { name: `${name}行业平均数`, data: averageData }
            ]
        };
    };

    // 异常指标columns
    getIndexColumns = () => {
        return [{
            title: '序号',
            width: 60,
            dataIndex: 'index'
        }, {
            title: '异常指标',
            width: 200,
            dataIndex: 'abnormalIndex',
            render: fieldAnomaly
        }, {
            title: '异常描述',
            dataIndex: 'abnormalDescription',
            render: (v) => <EllipsisAndTooltip text={v} />
        }, {
            title: '业务解释',
            dataIndex: 'businessExplain',
            render: (v) => <EllipsisAndTooltip text={v} />
        }, {
            title: '关注点',
            dataIndex: 'focusPoint',
            render: (v) => <EllipsisAndTooltip text={v} />
        }, {
            title: '异常情况',
            width: 80,
            dataIndex: 'operation',
            render: (v, d) => <a href="javascript:void(0)" onClick={() => this.showModal(d)}>查看</a>
        }];
    };

    // 异常指标指数columns
    getAbnormalIndexColumns = () => {
        const { indexValueData } = this.props;
        const header = indexValueData[0];

        if(isEmpty(header)) {
            return [{ title: '异常指标', dataIndex: 'abnormalIndex' }];
        }
        let columns = [];
        for(let i in header) {
            columns.push({
                title: header[i],
                dataIndex: i,
                render: i === 'abnormalIndex' ? fieldAnomaly : removeCommonIndex
            });
        }
        if (columns.length > 1) {
            columns[0].width = 200;
        }
        return columns;
    };

    render() {
        const { loading, indexData, indexValueData } = this.props;
        const { visible, chartTitle, modalOption } = this.state;
        const indexValueRealData = indexValueData.slice(1);

        return (
            <div>
                <div className="sub-title">异常指标</div>
                <Table
                    bordered
                    rowKey="abnormalIndex"
                    className="table-margin"
                    loading={loading}
                    dataSource={indexData}
                    columns={this.getIndexColumns()}
                    pagination={indexData.length > PAGE_SIZE}
                />

                <div className="sub-title">异常指标指数_括号内为项目原值</div>
                <Table
                    bordered
                    rowKey="abnormalIndex"
                    className={styles.tableFirstRow}
                    loading={loading}
                    dataSource={indexValueRealData}
                    columns={this.getAbnormalIndexColumns()}
                    pagination={indexValueRealData.length > PAGE_SIZE}
                />
                <Modal
                    width={730}
                    wrapClassName="vertical-center-modal"
                    visible={visible}
                    onCancel={this.hideModal}
                    footer={null}
                >
                    <div>
                        <p className="wrap-title">{chartTitle}</p>
                        <div className={styles.normalIndexTendLine}>
                            <BBDLineBar option={modalOption} />
                        </div>
                    </div>
                </ Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/overview/subComponents/common/IndexPane.jsx